import React from "react";
import './quote_slider.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {insertHtml} from "../../utils/dom";

class QuoteSlider extends TemplateComponent {

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = {
            isHidden: false
        };
    };

    playVideo = () => {
        this.myRef.current.play();
        this.setState({
            isHidden: true
        })
    };

    componentRender(data) {
        const settings = {
            dots: true,
            infinite: true,
            centerMode: false,
            centerPadding: "0",
            speed: 500,
            swipeToSlide: true,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        return (
            <div className="c34-quote-slider">
                <div className="quote-slider-slider-container d-flex align-items-end">
                    <div className={"slider-container"}>
                        <Slider {...settings}>
                            {data.quote.map((item, index) => (
                                <div key={index} className="quote-slider-slider-item">
                                    <div className="quote-slider-slider-title" {...insertHtml(item.title)}/>
                                    <div className="quote-slider-slider-date">{item.author}</div>
                                    <div className="quote-slider-slider-link">{item.content_small}</div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className={"box-right blue"}>
                        <h3 className={"box-right-title"}>{data.title_right}</h3>
                        <div className={"box-right-text"} {...insertHtml(data.content_right)} />
                        <a className={"button-link"} href={data.show_more_link}>Scopri le agevolazioni</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default QuoteSlider;
